import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the users api
 */
export class JobService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getSchedulerStatus() {		
		var status = await this.makeGETRequest('/api/service/jobs/scheduler/status');		
		return status;
	}
	
	async getSchedulerPause() {		
		var status = await this.makePUTRequest('/api/service/jobs/scheduler/pause');		
		return status;
	}
	
	async getSchedulerResume() {		
		var status = await this.makePUTRequest('/api/service/jobs/scheduler/resume');		
		return status;
	}	
	
	async getSharedJobs(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var jobs = await this.makeGETRequest('/api/service/jobs' + params);		
		return jobs;
	}
	
	async getJobAssignments(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var jobs = await this.makeGETRequest('/api/service/jobs/job-assignments' + params);		
		return jobs;
	}
	
	async deleteJobAssignment(jobAssignmentId) {		
		var result = await this.makeDELETERequest('/api/service/jobs/job-assignments/' + jobAssignmentId);		
		return result;
	}
	
	async deleteALLJobAssignment() {		
		var result = await this.makeDELETERequest('/api/service/jobs/job-assignments/all');		
		return result;
	}	
	
	async getJobPause(groupname, jobname) {		
		var job = await this.makePUTRequest('/api/service/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname) +'/pause');		
		return job;
	}	
	
	async getJobResume(groupname, jobname) {		
		var job = await this.makePUTRequest('/api/service/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname) +'/resume');		
		return job;
	}
	
	async getJobRunNow(groupname, jobname, parameters) {		
		var job = await this.makePUTRequest('/api/service/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname) +'/runnow', parameters);		
		return job;
	}
	
	async deleteJob(groupname, jobname) {		
		var result = await this.makeDELETERequest('/api/service/jobs/' +  encodeURIComponent(groupname) + '/' +  encodeURIComponent(jobname));		
		return result;
	}

	async reconcileSyncJobs() {
		var result = await this.makePOSTRequest('/api/service/jobs/reconcile/sync');
		return result;
	}
	
	async saveJob(job, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/service/jobs/' + encodeURIComponent(job.group) + '/' + encodeURIComponent(job.name), job);
		} else {
			saved = await this.makePOSTRequest('/api/service/jobs', job);
		}
		return saved;
	}

	exportJobs(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/service/jobs/export' + params);
	}
	
};

